<template>
    <b-container class="settings">
        <h1>You have sent all your Ready Msgs</h1>
        <div class="b-name"></div>
        <div class="mt-3">
            <b-row class="mt-5" align-h="center" align-v="start">
                    
                <b-col cols="10" sm="5">
                    <!-- <b-card class="pricing-card"> -->
                        <h2 class="red">Upgrade to keep texting</h2>
                        
                        <!-- <div class="mt-2">
                            <p class="inline">Current Plan:</p>
                            <p class="inline ml-3 stat">{{ plan }}</p>
                        </div>

                        <div>
                            <p class="inline">Ready Texts Limit:</p>
                            <p class="inline ml-3 stat">{{ textLimit }}</p>
                        </div> -->

                        <div class="mt-3">
                            <b-btn class="subs-btns submit-btn" @click="upgradeSubAlertDialog = true">Upgrade</b-btn>
                        </div>    
                    <!-- </b-card> -->
                </b-col>
            </b-row>
        </div>

        <div class="pricing-plans">
            <h2 class="mt-5">Plans</h2>
        <b-row align-h="center" align-v="start">
            <b-col cols="10" sm="4">
                <b-card class="pricing-card"
                    header="Starter"
                    header-tag="header"
                >
                    <b-card-text>$35/mo</b-card-text>
                    <!-- <b-card-text>$25/mo (Annual)</b-card-text> -->
                
                <div>
                    <ul class="list">
                        <li class="list-item">Ready Texts: 200</li>
                        <li class="list-item">Ready Emails: unlimited</li>
                        <li class="list-item">Support: Email</li>
                    </ul>
                </div>
                    
                </b-card>
            </b-col>

            <b-col cols="10" sm="4">
                <b-card class="pricing-card"
                    header="Standard"
                    header-tag="header"
                >
                    <b-card-text>$75/mo</b-card-text>
                    <!-- <b-card-text>$55/mo (Annual)</b-card-text> -->
                
                <div>
                    <ul class="list">
                        <li class="list-item">Starter Features</li>
                        <li class="list-item">Ready Texts: 500</li>
                        <li class="list-item">Text Marketing</li>
                    </ul>
                </div>
                    
                </b-card>
            </b-col>

            <b-col cols="10" sm="4">
                <b-card class="pricing-card"
                    header="Pro"
                    header-tag="header"
                >
                    <b-card-text>$125/mo</b-card-text>
                    <!-- <b-card-text>$95/mo (Annual)</b-card-text> -->
                
                <div>
                    <ul class="list">
                        <li class="list-item">Standard Features</li>
                        <li class="list-item">Ready Texts: 1,500</li>
                        <li class="list-item">Support: Email & Phone</li>
                    </ul>
                </div>
                    
                </b-card>
            </b-col>
        </b-row>
        </div>

        

        <!-- ______________________________________________ Alert Dialogs ___________________________________________________________________ -->
        <alert-dialog v-if="upgradeSubAlertDialog == true" class="alert-dialog" message="What plan would you like?">
        <b-btn class="cancel-update" @click="upgradeSubAlertDialog = false">X</b-btn>
        <p slot="currentPlan">Current Plan: {{ this.plan }}</p>
        <div slot="pricing-options">
          <b-form-group>
            <b-form-radio-group buttons id="checkboxes1" name="flavour1" v-model="selected" :options="options">
            </b-form-radio-group>
          </b-form-group>
          <p>{{ this.selected }}</p>
          <p v-if="this.selected == ''" class="warning">Please select a plan.</p>
        </div>
        <b-btn :disabled="((this.selected == '') || (this.btnClicked == true))" class="submit-btn" slot="successBtn" @click="updatePlan">Update</b-btn>
        <b-btn class="cancel-btn" slot="cancelBtn" @click="upgradeSubAlertDialog = false">Cancel</b-btn>
      </alert-dialog>

        <alert-dialog v-if="successAlertDialog == true" class="alert-dialog" :message="successMessage">
            <b-btn class="cancel-update" @click="successAlertDialog = false">X</b-btn>
        </alert-dialog>

        <alert-dialog v-if="failAlertDialog == true" class="alert-dialog" :message="failMessage">
            <b-btn class="cancel-update" @click="failAlertDialog = false">X</b-btn>
        </alert-dialog>

        <div class="loader" v-if="isLoading">
            <Loader />
        </div>
    </b-container>
</template>

<script>
import AlertDialog from "../../components/alert-dialog/AlertDialog"
import Loader from "../../components/Loader"
import TagTable from "../../components/settings/tags/TagTable"
import { db } from '@/main'
import firebase, { firestore } from 'firebase'
import axios from 'axios'
export default {
    components: {
        Loader,
        AlertDialog,
        TagTable
    },
    data() {
        return {
            businessName: '',
            plan: '',
            textLimit: '',
            currentTexts: '',
            upgradeSubAlertDialog: false,
            selected: 'Starter',
            options: ['Starter', 'Standard', 'Pro'],
            btnClicked: false,
            updateStripeSubApi: 'https://us-central1-readytextme.cloudfunctions.net/updateStripeSubscription',
            stripeErrorMsg: '',
            isLoading: false,
            successAlertDialog: false,
            successMessage: '',
            failAlertDialog: false,
            failMessage: '',
        }
    },
    methods: {
        async updatePlan () {

            this.stripeErrorMsg = '';

            if (this.selected != '') {

                this.isLoading = true;

                this.upgradeSubAlertDialog = false;

                this.btnClicked = true;

                let plan = ''
                if (this.selected == "Starter") {
                    plan = 'starter';
                }

                if (this.selected == "Standard") {
                    plan = 'standard';
                }

                if (this.selected == "Pro") {
                    plan = 'pro';
                }

                var postContent = {
                    'uid': firebase.auth().currentUser.uid,
                    'pricingPlan': plan,
                    'token': {}
                }

                // console.log('postContent' + JSON.stringify(postContent));

                try {
                    await axios.post(
                    this.updateStripeSubApi,
                    postContent,
                    {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    })
                    this.btnClicked = false;

                    this.isLoading = false;
                    this.successMessage = 'Plan successfully updated';
                    this.successAlertDialog = true;
                } catch (error) {
                    console.log(error);
                    this.failMessage = 'Plan failed to update';
                    this.failAlertDialog = true;
                    // this.stripeErrorMsg = JSON.stringify(error.response);
                    this.isLoading = false;
                    this.btnClicked = false;  
                }
            } else {
                this.stripeErrorMsg = '';
                this.isLoading = false;
                this.btnClicked = false;
            }
        },

    },
    async created() {
        var vueInstance = this;
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            vueInstance.businessName = doc.data().business;
            vueInstance.plan = doc.data().plan;
            vueInstance.currentTexts = doc.data().readyTextsSent;
            const business = doc.data().business;
            if (vueInstance.plan == "trial") {
                vueInstance.textLimit = '20'
            }
            
            if (vueInstance.plan == "starter") {
                vueInstance.textLimit = '200'
            }

            if (vueInstance.plan == "standard") {
                vueInstance.textLimit = '500'
            }

            if (vueInstance.plan == "pro") {
                vueInstance.textLimit = '1,500'
            }

            const businessSnapshot = await db.collection('businesses').doc(business).onSnapshot(async (docc) => {
                vueInstance.items = [];
                // console.log(vueInstance.tags);

            });
        });
    },
}
</script>

<style scoped>
.settings {
    margin-top: 100px;
}

.pricing-card {
    margin-top: 20px;
    background-color: #f5f4f4;
    /* background-color: #DA2a2a; */
    /* min-height: 400px; */
    /* padding: 30px 20px 5px 20px; */
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #d1d1d1;
}

.inline {
    display: inline;
    text-align: start;
}

.subs-btns {
    margin: 3px 5px;
}

.red {
    color: #bb2828;
}

.cancel-update {
  background-color: #E05555;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  font-size: 1em;
}

.alert-dialog {
  position: fixed;
  border: 1px solid #929292;
  border-radius: 5px;
  padding: 20px 20px;
  background-color: #ececec;
  width: 700px;
  z-index: 3;
  top: 30%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
}

.warning {
  color: #dd7d2e !important;
}

.b-name {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    padding-top: 2px;
    border-bottom: 3px solid #DA2a2a;
    /* border-radius: 10px; */
}

.loader {
    position: fixed;
    width: 350px;
    height: 350px;
    z-index: 100;
    padding-top: 70px;
    /* top: 0; */
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #c0c0c0;
    border-radius: 5px;
    transition: all 0.8s ease;
}

.red {
    /* color: #ffffff; */
    color: #DA2a2a;
}

.stat {
    font-weight: 600;
    letter-spacing: 1px;
}

.exit-button {
    position: absolute;
    left: 0;
    margin-left: 20px;
    transform: translateY(-20px);
    font-size: 18px;
}

.left-align-text {
    text-align: left;
}

.current-text-template {
    padding-left: 20px;
    color: #7e7e7e;
    font-weight: 500;
    text-align: left;
}

.translate-y-down {
    transform: translateY(20px);
}

.list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    padding-top: 15px;
    border-top: 1px solid #e2e2e2;
}

.list-item {
    text-align: center;
}

@media (max-width: 600px) {
    .alert-dialog {
        width: 380px;
    }
}
</style>
